import styled, { css } from 'styled-components';
import { pickToken } from '../../../../forms/styles/helper';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const ICON_WIDTH = 44;
const blockListItemStyles = ({ theme, $colorContext, }) => css `
	display: grid;
	grid-template-areas:
		'icon title'
		'text text';
	grid-template-columns: ${pxToRem(ICON_WIDTH)} 1fr;
	gap: ${pxToRem(theme.spacing['100'])} ${pxToRem(theme.spacing['300'])};
	align-items: center;
	padding: ${pxToRem(theme.spacing['400'])};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	background-color: ${pickToken({
    'on-light': theme.colors.extralight.bgBlocksSecondary,
    'on-medium': theme.colors.blanc.bgBlock,
    'on-dark': theme.colors.blanc.bgBlock,
}, $colorContext)};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		grid-template-areas:
			'icon title'
			'icon text';
		align-items: start;
		column-gap: ${pxToRem(theme.spacing['400'])};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		column-gap: ${pxToRem(theme.spacing['500'])};
		padding: ${pxToRem(theme.spacing['500'])};
	}
`;
export const StyledBlockListItem = styled.li `
	${blockListItemStyles}
`;
